<ng-container *ngIf="isDialogOpened">
  <kendo-window [title]="dialogTitle | translate"
                [width]="600"
                [height]="220"
                (close)="cancel()">
    <div class="dialog-content-container">
      <table aria-hidden="true">
        <tr>
          <td class="align-left"><img src="./assets/images/question.png" alt="question" /></td>
          <td class="dialog-confirm-message">{{ dialogMessage | translate}} {{parameter}}</td>
        </tr>
      </table>
    </div>
    <div class="dialog-buttons-container">
      <div class="buttons-bar-border">
        <div class="button-bar">
          <button kendoButton class="button-confirm" (click)="confirm()" id="delete-confirm">{{ 'projectValuationConfirmDeleteProjectstdDialog.confirm' | translate }}</button>
          <button kendoButton class="button-confirm" (click)="cancel()" id="delete-cancel">{{ 'projectValuationConfirmDeleteProjectstdDialog.cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </kendo-window>
  <div class="k-overlay overlay-confirm-dialog"></div>
</ng-container>
